import { createReducer } from 'utils/redux';
import { fromJS } from 'immutable';
import * as actionTypes from './actionTypes';
import initialState from './initialState';

export default createReducer(fromJS(initialState), {
  [actionTypes.GET_OKVEDS]: (state) =>
    state.setIn(['all', 'loading'], true).setIn(['all', 'error'], null),
  [actionTypes.GET_OKVEDS_SUCCESS]: (state, { payload }) =>
    state.setIn(['all', 'loading'], false).setIn(['all', 'data'], fromJS(payload)),
  [actionTypes.GET_OKVEDS_FAILURE]: (state, { payload }) =>
    state.setIn(['all', 'loading'], false).setIn(['all', 'error'], fromJS(payload)),
  [actionTypes.GET_POPULAR_OKVEDS]: (state) =>
    state.setIn(['popular', 'loading'], true).setIn(['popular', 'error'], null),
  [actionTypes.GET_POPULAR_OKVEDS_SUCCESS]: (state, { payload }) =>
    state.setIn(['popular', 'loading'], false).setIn(['popular', 'data'], fromJS(payload)),
  [actionTypes.GET_POPULAR_OKVEDS_FAILURE]: (state, { payload }) =>
    state.setIn(['popular', 'loading'], false).setIn(['popular', 'error'], fromJS(payload)),
});
